module.exports = __webpack_public_path__ + "static/img/7.478a308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/7.png
// module id = 136
// module chunks = 2